<template>
  <v-app >
    <v-content>
      <router-view/>
      <v-snackbar
              :color="snackbar.color"
              :timeout="snackbar.timeout"
              bottom
              right
              v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn @click.native="snackbar.show = false" dark  icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>


<script>
import colors from 'vuetify/es5/util/colors';
import {mapGetters} from "vuex";

export default {
  name: "App",
  data() {
    return {
      rightDrawer: false,
      colors: colors
    };
  },
  computed:{
  ...mapGetters("Notification", ["snackbar"]),

  },
  methods: {
    openThemeSettings () {
      this.$vuetify.goTo(0);
      this.rightDrawer = (!this.rightDrawer);
    }
  },
  mounted() {
    this.$vuetify.theme.primary = this.colors['indigo'].base;
  }
};

</script>
